import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiError, api, type Session } from './api';

/** `null` = not signed in. A 401 is a normal answer here, not an error. */
export const sessionQuery = queryOptions({
  queryKey: ['session'],
  queryFn: async (): Promise<Session | null> => {
    try {
      return await api.session();
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) return null;
      throw e;
    }
  },
  staleTime: 60_000,
});

export const useSession = () => useQuery(sessionQuery);

export const useInvalidateSession = () => {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ['session'] });
};
